module.exports = __webpack_public_path__ + "img/minor-gold.10e446df.webp";